import React from 'react'
import { Typography } from 'antd'
import { s } from './style'
import { TelephoneSVG } from './TelephoneSVG'

const { Title } = Typography

interface NoAcceptedProposalProps {
  accountManagerEmail: string | null
}

export const NoAcceptedProposal = ({
  accountManagerEmail,
}: NoAcceptedProposalProps): JSX.Element => (
  <div style={s.wrapper}>
    <div style={s.root}>
      <TelephoneSVG />
      <Title
        level={2}
        style={{
          fontSize: 16,
          lineHeight: '24px',
          color: 'black',
        }}
      >
        {`We’re having trouble showing the details of your event. Don’t worry, our team has all the details - ${
          accountManagerEmail
            ? `contact ${accountManagerEmail}`
            : 'get in touch'
        } if you have any questions.`}
      </Title>
    </div>
  </div>
)
